var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard_home",staticStyle:{"background-color":"#F5F5FD"}},[_c('Sidebar'),(_vm.getViewPort() >= 1000)?_c('span'):_c('Footer',{staticClass:"footer-width is-hidden-desktop"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }